/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "mkfryvtbgefemcauqakh"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1rZnJ5dnRiZ2VmZW1jYXVxYWtoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzIyMDE3NTMsImV4cCI6MjA4Nzc3Nzc1M30.hRR1yhpLhRyO_Hr8VCPBw5Wmb-2PxI-xCzVNhyze05I"